<section class="admin-section">
  <div class="admin-section__header">
    <div>
      <h2 class="admin-section__title">
        {{ "COMPONENTS.ADMIN_PANEL.ADMINS.TITLE" | translate }}
      </h2>
      <p class="admin-section__subtitle">
        {{ "COMPONENTS.COMPANIES.PLATFORM_ADMINS_HINT" | translate }}
      </p>
    </div>
  </div>

  <div class="admin-grant-form">
    <label class="admin-grant-form__label" for="super-admin-email">
      {{ "COMPONENTS.ADMIN_PANEL.ADMINS.INPUT_LABEL" | translate }}
    </label>
    <div class="admin-grant-form__controls">
      <input
        id="super-admin-email"
        type="email"
        class="input-field-lg admin-grant-form__input"
        [formControl]="superAdminEmailControl"
        [placeholder]="'COMPONENTS.COMPANIES.PLATFORM_ADMINS_PLACEHOLDER' | translate"
      />
      <button
        type="button"
        class="btn-primary admin-grant-form__button"
        [disabled]="!canSubmitGrant || isGrantSubmitting"
        (click)="grantSuperAdmin()"
      >
        {{ "COMPONENTS.COMPANIES.GRANT_SUPER_ADMIN" | translate }}
      </button>
    </div>
  </div>

  @if (isLoading) {
    <p class="admin-section__empty">
      {{ "MESSAGES.LOADING" | translate }}
    </p>
  } @else if (superAdmins.length > 0) {
    <div class="admin-admins-list">
      @for (superAdmin of superAdmins; track superAdmin.userId) {
        <article class="admin-admins-list__item">
          <div class="admin-admins-list__details">
            <h3 class="admin-admins-list__name">
              {{ superAdmin.fullName || superAdmin.email }}
            </h3>
            <p class="admin-admins-list__email">
              {{ superAdmin.email }}
            </p>
          </div>

          @if (superAdmin.userId === currentUserId) {
            <span class="admin-admins-list__badge">
              {{ "COMPONENTS.ADMIN_PANEL.ADMINS.CURRENT_USER" | translate }}
            </span>
          } @else {
            <button
              type="button"
              class="btn-secondary admin-admins-list__action"
              (click)="revokeSuperAdmin(superAdmin.userId)"
            >
              {{ "COMPONENTS.COMPANIES.REVOKE_SUPER_ADMIN" | translate }}
            </button>
          }
        </article>
      }
    </div>
  } @else {
    <p class="admin-section__empty">
      {{ "COMPONENTS.COMPANIES.PLATFORM_ADMINS_EMPTY" | translate }}
    </p>
  }
</section>
